import React from 'react';

import { IconButton } from 'packages/common-frontend/components/IconButton';
import { FiEye, FiEyeOff } from 'react-icons/fi';

export type TapeBuilderDiffDocument = {
  oldValue: {
    id: string;
    version: number;
  };
  newValue: {
    id: string;
    version: number;
  };
};

export const DiffIconButton = ({
  diff,
  setDiff,
  newDiff,
}: {
  diff: TapeBuilderDiffDocument | null;
  setDiff: (diff: TapeBuilderDiffDocument | null) => void;
  newDiff: TapeBuilderDiffDocument | null;
}) => {
  if (diff) {
    return (
      <IconButton
        label="Hide diff"
        icon={<FiEyeOff />}
        variant="outline"
        onClick={() => setDiff(null)}
        aria-label="Hide diff"
        ariaLabel="Hide diff"
      />
    );
  }
  return (
    <IconButton
      isDisabled={!newDiff}
      label="Show diff"
      icon={<FiEye />}
      variant="outline"
      onClick={() => setDiff(newDiff)}
      aria-label="Show diff"
      ariaLabel="Show diff"
    />
  );
};
